import axios from '@/plugins/axios'

export function getDoubleProductList(queryInfo) {
	return axios({
		url: 'jd/double/page',
		method: 'GET',
		params: {
			...queryInfo
		}
	})
}
export function removeRepeat() {
	return axios({
		url: 'jd/double/removeRepeat',
		method: 'DELETE'
	})
}

export function removeBlankPreferential() {
	return axios({
		url: 'jd/double/removeBlankPreferential',
		method: 'PUT'
	})
}

export function removeByIds(ids) {
	return axios({
		url: 'jd/double/removeByIds?ids=' + ids,
		method: 'DELETE'
	})
}

export function restoreDelete(id) {
	return axios({
		url: 'jd/double/restoreDelete/' + id,
		method: 'PUT'
	})
}

export function exportExcel() {
	return axios({
		url: 'jd/double/export',
		method: 'GET'
	})
}

export function listPreferentialDistinct(onlyNoClicked) {
	return axios({
		url: 'jd/double/listPreferentialDistinct/' + onlyNoClicked,
		method: 'GET'
	})
}

export function genConfirm(data) {
	return axios({
		url: '/v1/tools/genConfirm',
		method: 'POST',
		data: data
	})
}

export function convertQrCode(data) {
	return axios({
		url: '/v1/tools/convertqrcode',
		method: 'POST',
		data: data
	})
}